const InstrumentType = Object.freeze({
    MERIT_BADGE: "MERIT_BADGE",
    TRAIL_BADGE: "TRAIL_BADGE",
    RANK: "RANK",
    CHALLENGE: "CHALLENGE",
});

export default InstrumentType;
